<template>
    <div class="flex flex-col gap-4">
      <div class=" w-auto  border-none ">
        <p class="text-[21px] font-semibold text-center mt-4">Upload new media</p>
        <p class="text-[18px] font-normal text-center leading-6	px-3">To successfully upload your photos and videos, make sure they follow dKilo's
            <span @click="isMediaGuidelines =!isMediaGuidelines" class="text-primary underline leading-6 font-normal cursor-pointer">Media guidelines.</span></p>

        <div class="flex w-full px-10 flex-col justify-center items-center mt-[72px] gap-4 md:flex-row">
          <div class="card bg-[#D5F2F1] w-full md:w-1/3 flex-col p-7 flex-wrap text-center content-center border border-primary"
            v-bind:class="{ 'cursor-not-allowed opacity-60': activeDiv !== 1 }"
            @click="setActiveDiv(1)">
            <p class="text-[21px]">Upload Your Media</p>

            <input
              type="file"
              id="upload"
              multiple
              @click="handleUploadClicked"
              @change="handleFileUpload"
              class="hidden"
            />
            <div class="flex justify-center items-center">
              <label for="upload" class="w-auto mx-[18%] text-sm text-gray-500  py-2 px-4 rounded-full border-0 text-sm font-semibold bg-gray-50 text-primary hover:bg-gray-200 ">Upload File</label>
            </div>
            <p class="text-gray-500 text-[14px]"
            :class="[
                  !formFiles
                    ? 'text-red-500'
                    : '',
                    ]"
            >
              {{ fileName !== "" ? fileName : "No files Chosen" }}
            </p>
            <p v-if="error && !formFiles" class="text-red-500">{{ error }}</p>
            <div
              class="flex flex-wrap items-center justify-center"
              v-if="formFiles"
            >
              <img
                :src="formFiles"
                v-if="isImage"
                class="max-w-36 max-h-36"
              />
              <video
                v-else
                :src="formFiles"
                class="max-w-36 max-h-36"
              ></video>
            </div>
            <p class="text-[14px] leading-5">
              <span class="font-semibold">Duration:</span> 30 Seconds
            </p>
            <p class="text-[14px] leading-5">
              <span class="font-semibold">Files Supported:</span> Videos, Images, GIFs
            </p>
            <p class="text-[14px] leading-5">
              <span class="font-semibold">Maximum Size :</span> 20 MBs
            </p>
            <!-- <p class="text-[14px] font-semibold">
              Resolution and Aspect Ratio of the Screen (1920 px * 640 px), (3.0 - 3.1)
            </p> -->
          </div>
          <div
            class="card bg-[#D5F2F1] border border-primary w-full  md:w-1/3 flex flex-col items-center text-center"
            v-bind:class="{ 'cursor-not-allowed opacity-60': activeDiv !== 2 }"
             @click="setActiveDiv(2);"
          >
            <p class="text-[21px]">Create Your Own Design</p>
            <img
                :src="canvaImgSrc"
                v-if="canvaImgSrc !== '' && activeDiv === 2"
                class="max-w-36 max-h-36 mt-3"
            />
            <p v-if="canvaImgSrc !== '' && activeDiv === 2" class="text-gray-500 text-[14px]">{{ $store.state.imgName }}</p>
            <button
              id="canvabtn"
              style="margin-top: 55px;"
              class="canva-btn canva-btn-theme-default canva-btn-size-s w-52 mb-20"
            >
              <span class="canva-btn-i"></span>
              Design on Canva
            </button>
            <!-- <p class="text-[14px] font-semibold">
              Resolution and Aspect Ratio of the Screen (1920 px * 640 px), (3.0 - 3.1)
            </p> -->
          </div>
        </div>

        <div
          v-if="errorMessage"
          class="text-red-400 flex justify-center items-center mt-2"
        >
          {{ errorMessage[0] }}
        </div>
      </div>
      <div class="flex flex-col mt-[72px] text-center">
        <p class="text-[21px] font-semibold">Terms & Policies</p>

        <div class="flex items-center md:items-center  md:justify-center p-3 m-0">
          <label class="p-0 m-0" @click="acceptTrem()">
            <svg
              v-if="clicked"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g
                id="svgexport-6_-_2022-10-27T125207.565"
                data-name="svgexport-6 - 2022-10-27T125207.565"
                transform="translate(-2 -2)"
              >
                <g id="check">
                  <path
                    id="Path_26715"
                    data-name="Path 26715"
                    d="M19,2H5A3.009,3.009,0,0,0,2,5V19a3.009,3.009,0,0,0,3,3H19a3.009,3.009,0,0,0,3-3V5A3.009,3.009,0,0,0,19,2Zm-2.54,8.21-5,5a1.014,1.014,0,0,1-1.42,0l-2.5-2.5a1,1,0,0,1,1.42-1.42l1.79,1.8,4.29-4.3a1,1,0,1,1,1.42,1.42Z"
                    fill="#369da3"
                  />
                </g>
              </g>
            </svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g
                id="svgexport-6_-_2022-10-27T125207.565"
                data-name="svgexport-6 - 2022-10-27T125207.565"
                transform="translate(-2 -2)"
              >
                <g id="check">
                  <path
                    id="Path_26715"
                    data-name="Path 26715"
                    d="M19,2H5A3.009,3.009,0,0,0,2,5V19a3.009,3.009,0,0,0,3,3H19a3.009,3.009,0,0,0,3-3V5A3.009,3.009,0,0,0,19,2Zm-2.54,8.21-5,5a1.014,1.014,0,0,1-1.42,0l-2.5-2.5a1,1,0,0,1,1.42-1.42l1.79,1.8,4.29-4.3a1,1,0,1,1,1.42,1.42Z"
                    fill="#d6d6d6"
                  />
                </g>
              </g>
            </svg>
          </label>
          <label for="link-checkbox" class="  md:ml-2 text-[18px] font-normal leading-6 text-black  pl-3 m-0">
            I agree with the
            <a
              href="https://www.dkilo.com/advertiser-terms"
              target="_blank"
              class="text-primary hover:underline"
              >Terms of Service,
            </a>
            <a
              href="https://www.dkilo.com/privacy-policy"
              target="_blank"
              class="text-primary hover:underline"
            >
              Privacy Policy
            </a>
            <span class="text-black hover:no-underline mx-1">and</span>
            <a
              href="https://www.dkilo.com/advertising-policies"
              target="_blank"
              class="text-primary hover:underline"
            >
              Advertising Policies.</a
            >
          </label>
        </div>
        <div v-if="acceptPolicy" class="text-red-500">
          Please Accept the Terms of Service, Privacy Policy and Advertising
          Policies!
        </div>
        <div v-if="isError">
          <p class="text-red-500">You must upload a file or create a design using Canva</p>
        </div>
      </div>
    </div>

    <div class="flex gap-2 items-center justify-end flex-wrap m-6">
      <button
        class="bg-white p-2 px-[66px] rounded-[5px] text-primary border-2 border-primary w-full md:w-fit"
        @click="back()"
        v-if="$store.state.step > 1"
      >
        Back
      </button>
      <button
        class="bg-primary p-2 px-[66px] rounded-[5px] text-white w-full md:w-fit"
        :class="[error || !formFiles && canvaFiles == false ? 'disabled:opacity-50' : '']"
        v-if="$store.state.step == 3"
        @click="next"
      >
        Submit
      </button>

    </div>
    <modal v-if="isModal" class="z-50" />
    <MediaGuidelinesModal v-if="isMediaGuidelines" class="z-50" :isMediaGuidelines="isMediaGuidelines"
      @close-modal="isMediaGuidelines = false"/>
    <ReviewAndPay v-if="ReviewPaymentState === true"
      @handleCancel="handleCancelEvent"
      @handleSuccess="handleSuccessEvent"
      @handleError="handleErrorEvent"
      :campaignId="this.currentCampaignId"
    />
    <PaymentSuccess v-if="paymentStatusSuccess" @closePopup="handleClosePopupEvent" />
    <PaymentCancel v-if="paymentStatusCancel" @closePopup="handleClosePopupEvent"/>
    <PaymentFaild v-if="paymentStatusfalid" @closePopup="handleClosePopupEvent" />
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
  </template>

  <script>
  import store from "../../store";
  import Modal from "../UI/Modal.vue";
  import { mapGetters } from "vuex";
  import MediaGuidelinesModal from "../UI/MediaGuidelinesModal.vue";
  import ReviewAndPay from "./ReviewAndPay.vue";
  import PaymentSuccess from "./PaymentSuccess.vue";
  import PaymentCancel from "./PaymentCancel.vue";
  import PaymentFaild from "./PaymentFaild.vue";


  export default {
    components: { Modal , MediaGuidelinesModal, ReviewAndPay, PaymentSuccess, PaymentCancel, PaymentFaild},
    data() {
      return {
        link:{
          link_name:null,
          link_duration:null,
        },
        activeDiv: 1,
        uploadProgress: null,
        // files: [],
        accept: ["image/jpeg", "video/mp4"],
        formFiles: null,
        canvaFiles:false,
        selectedFiles: "",
        clicked: false,
        errorMessage: "",
        errors: [],
        errorsValue: [],
        errorsKey: [],
        acceptPolicy: false,
        imgName: "",
        error: null,
        isImage: false,
        isMediaGuidelines:false,
        paymentStatusSuccess: false,
        paymentStatusCancel: false,
        paymentStatusfalid: false,
        currentCampaignId: "",
        fileName: "",
        canvaImgSrc: '',
        isError: false,
        isLoading: false,
      };
    },
    computed: {
      ...mapGetters(["isModal", "ReviewPaymentState"]),
    },
    mounted() {
      //Change Document Title
      document.title = "dKilo Ad Manager - Confirm";
      (async () => {
        if (!window.Canva || !window.Canva.DesignButton) {
          return;
        }

        const api = await window.Canva.DesignButton.initialize({
          apiKey: "tqaNwK-i0ZsW36dcFbO0qdv9",
          // apiKey: "IzIUZh6g0siFtSgcPTnIOCWI",
          headers: {
            "Referrer-Policy": "no-referrer",
            "Referrer-Policy": " no-referrer-when-downgrade",
          },
        });

        const button = document.getElementById("canvabtn");

        button.onclick = () => {
          api.createDesign({
            design: {
              type: "FacebookAd",
              dimensions: {
                width: 1920,
                height: 640,
              },
            },
            editor: {
              publishLabel: "Save",
              fileType: "jpg",
            },
            onDesignPublish: ({ exportUrl, designId }) => {
              this.handleCanvaUpload(exportUrl, designId);
            },

            onDesignOpen: ({ designId }) => {
              // Triggered when editor finishes loading and opens a new design.
              // You can save designId for future use.
            },
            // onDesignPublish: ({ exportUrl, designId }) => {
            //     // Triggered when design is published to an image.
            //     // Save the image to your server as the exportUrl will expire shortly.
            //     this.onDesignPublish(exportUrl, designId);
            // },
            onDesignClose: () => {
              // Triggered when editor is closed.
            },
          });
        };
      })();
    },
    methods: {
      setActiveDiv(divNumber) {
        this.activeDiv = divNumber;
        if (divNumber === 1) {
          this.link.link_name = null;
          this.link.link_duration = null;
          // this.formFiles = null;
          console.log(store.state.imgName);
          store.commit("updateImgName", this.imgName)
        }else if (divNumber === 2) {
          this.link.link_name = null;
          this.link.link_duration = null;
          this.formFiles = null;
          this.fileName = "";
        } else if(divNumber === 3) {
          // this.formFiles = null;
          console.log(store.state.imgName);
          store.commit("updateImgName", this.imgName)
        }
      },
      handleClosePopupEvent(popupType){
        this[`${popupType}`] = false
      },
      handleCancelEvent(){
        store.commit('closeReviewPayment');
        this.paymentStatusCancel = true;
      },
      handleSuccessEvent(){
        store.commit('closeReviewPayment');
        this.paymentStatusSuccess = true;
      },
      handleErrorEvent(){
        store.commit('closeReviewPayment');
        this.paymentStatusfalid = true;
      },
      handleCanvaUpload(exportUrl, designId) {
        fetch(exportUrl)
          .then(
            (response) => response.blob()
            // console.log(blob);
            // console.log(response.blob());
          )
          .then((blob) => {
            let file = new File([blob], `canva-${designId}.jpeg`, {
              type: "image/jpeg",
            });
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              let imgSrc = reader.result;
              this.canvaImgSrc = imgSrc;
            };
            this.canvaFiles = true;
            this.imgName = file.name;
            // console.log(this.formFiles);
            // console.log(this.imgName);
            // console.log(file);
            store.commit("updastateStepFour", file);
            store.commit("updateImgName", this.imgName);
          });
      },
      acceptTrem() {
        this.clicked = !this.clicked;
        if(this.clicked === true){
          this.acceptPolicy = false;
        }
      },
      handleUploadClicked() {
        console.log('this.formFiles: ',this.formFiles);
      },
      // uploadFileUploadToS3(file) {
      //   // const file = event.target.files[0];
      //   // console.log(file);
      //      uploadFile(file).then(response => {
      //     console.log('File uploaded successfully', response);
      //   }).catch(error => {
      //     console.error('Upload failed', error);
      //   });
      // },

      handleFileUpload(e) {
        const file = e.target.files[0];
        this.fileName = file.name;
        const maxWidth = 1920;
        const maxHeight = 1080;
        const maxDuration = 35
        const maxSizeInMB = 20 * 1024 * 1024; // 20 MB in bytes
        if (file) {
          const fileSize = file.size;
          if (fileSize > maxSizeInMB) {
              this.error = "File size exceeds the maximum limit (20 MB). Please upload a smaller file.";
              this.formFiles = null;
              return;
          }
        }
        if (file) {
          const fileType = file.type;
          if (fileType.startsWith("image/")) {
            this.handleImageUpload(file, maxWidth, maxHeight);
            this.isImage = true;
          } else if (fileType.startsWith("video/")) {
            this.isImage = false;
            this.handleVideoUpload(file, maxWidth, maxHeight, maxDuration);
          } else {
            this.error = "Please upload an image or video file.";
            this.formFiles = null;
          }
        } else {
          this.error = "No file selected.";
          this.formFiles = null;
        }
      },

      handleImageUpload(file, maxWidth, maxHeight) {
        const img = new Image();
        const reader = new FileReader();
        reader.readAsDataURL(file);
        const maxSizeInMB = 20 * 1024 * 1024; // 20 MB in bytes
        reader.onload = (e) => {
          img.onload = () => {
            const width = img.width;
            const height = img.height;
            const imageAspectRatio = width / height;
            console.log(imageAspectRatio);
            if(file.size > maxSizeInMB){
              this.error = `File size exceeds the maximum limit (20 MB). Please upload a smaller file.`;
              this.formFiles = null;
            }
            if (imageAspectRatio !== 3/1 && imageAspectRatio !== 16/9) {
              this.error = `Please upload an image with a maximum size of ${maxWidth}x${maxHeight} and an aspect ratio of 3.0 to 3.1.`;
              this.formFiles = null;
            } else {
              this.error = null;
              this.formFiles = e.target.result;
              // store.commit("updastateStepFour", `https://dkilo-production-uploads.s3.eu-west-1.amazonaws.com/campaignsImages/${file.name}`);
              // this.uploadFileUploadToS3(file);
              store.commit("updastateStepFour", file);
            }
            // store.commit("updastateStepFour", `https://dkilo-production-uploads.s3.eu-west-1.amazonaws.com/campaignsImages/${file.name}`);
            // this.uploadFileUploadToS3(file);
            store.commit("updastateStepFour", file);
          };

          img.src = e.target.result;
        };
      },

      handleVideoUpload(file, maxWidth, maxHeight, maxDuration) {
        const video = document.createElement("video");
        const videoElement = document.getElementById("videoElement");
        video.preload = "metadata";
        video.onloadedmetadata = () => {
          const width = video.videoWidth;
          const height = video.videoHeight;
          const videoAspectRatio = width / height;
          const duration = video.duration;

          // if (
          //   width > maxWidth ||
          //   height > maxHeight ||
          //   videoAspectRatio < 3.0 ||
          //   videoAspectRatio > 3.1 ||
          //   duration >= maxDuration
          // ) {
          //   this.error = `Please upload a video with a maximum size of ${maxWidth}x${maxHeight}, aspect ratio of 3.0 to 3.1, and a maximum duration of ${maxDuration} seconds.`;
          //   this.formFiles = null;
          // } else {
          //   this.error = null;
          //   this.formFiles = URL.createObjectURL(file);
          //   // this.uploadFileUploadToS3(file);
          //   // store.commit("updastateStepFour", `https://dkilo-production-uploads.s3.eu-west-1.amazonaws.com/campaignsImages/${file.name}`);
          //   store.commit("updastateStepFour", file);
          // }
          this.error = null;
          this.formFiles = URL.createObjectURL(file);
          // this.uploadFileUploadToS3(file);
          // store.commit("updastateStepFour", `https://dkilo-production-uploads.s3.eu-west-1.amazonaws.com/campaignsImages/${file.name}`);
          store.commit("updastateStepFour", file);
        };

        video.src = URL.createObjectURL(file);
      },
      async next() {
        if (!this.clicked) {
          this.acceptPolicy = true;
        } else {
          this.acceptPolicy = false;
        }
        if(!this.formFiles && !this.canvaFiles){
          this.isError = true;
        }
        if (this.clicked && (this.formFiles || this.canvaFiles)) {
          this.isError = false
          this.isLoading = true; // Start loading
          try {
              const result = await this.$store.dispatch('uploadFromVuex', 'test'); // Wait for dispatch to finish
              console.log('result id ===>: ', result);
              this.currentCampaignId = result.id;
              // Commit openReviewPayment only AFTER successful dispatch
              this.$store.commit("openReviewPayment");
          } catch (error) {
              console.error('Error during upload:', error);
              // Attempt to get specific error message from store if available
              const storeError = this.$store.getters.getError;
              this.errorMessage = storeError ? storeError : 'An error occurred during upload.';
              // Ensure errorMessage is an array if the getter returns an object/string
              if (typeof this.errorMessage === 'string') {
                this.errorMessage = [this.errorMessage];
              } else if (typeof this.errorMessage === 'object' && this.errorMessage !== null && !Array.isArray(this.errorMessage)) {
                 // Handle potential error object structures if needed, otherwise fallback
                 this.errorMessage = ['An unexpected error format occurred.'];
              } else if (!Array.isArray(this.errorMessage)) {
                 this.errorMessage = ['An unknown error occurred.'];
              }

          } finally {
              // Stop loading regardless of success or error
              this.isLoading = false;
          }
        } else {
          // Handle cases where validation fails before dispatch
          if (!this.clicked) {
            this.acceptPolicy = true;
          }
          if (!this.formFiles && !this.canvaFiles) {
             this.isError = true;
          }
          console.log("Validation failed or terms not accepted.");
        }
      },
      back() {
        if (this.$store.state.step > 1) {
          this.$store.state.step = this.$store.state.step - 1;
        }
        window.scrollTo(0, 0);
      },
    },
  };
  </script>

  <style>
  .canva-btn {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smooth: always;
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    line-height: 1.6;
    box-sizing: border-box;
    user-select: none;
    cursor: pointer;
    border: 1px solid transparent;
    max-width: 100%;
    min-width: 80px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    transition: background-color 0.1s linear;
  }

  .canva-btn-i {
    background-size: contain;
  }

  .canva-btn-theme-default {
    background-color: #7d2ae8;
    color: #ffffff;
  }

  .canva-btn-theme-default:hover,
  .canva-btn-theme-default:focus {
    background-color: #8d39fa;
  }

  .canva-btn-theme-default:active {
    background-color: #6718cf;
  }

  .canva-btn-theme-dark {
    background-color: #0e1318;
    color: #ffffff;
  }

  .canva-btn-theme-light {
    border-color: #9a9da3;
    background-color: #ffffff;
    color: #0e1318;
  }

  .canva-btn-theme-light:active {
    background-color: #f8f9f9;
  }

  .canva-btn-size-l {
    height: 48px;
    border-radius: 5px;
    font-size: 16px;
    padding-right: 16px;
  }

  .canva-btn-size-l .canva-btn-i {
    width: 32px;
    height: 32px;
    margin-left: 11px;
    margin-right: 13px;
  }

  .canva-btn-size-m {
    height: 40px;
    border-radius: 4px;
    font-size: 14px;
    padding-right: 16px;
  }

  .canva-btn-size-m .canva-btn-i {
    width: 24px;
    height: 24px;
    margin: 0 9px;
  }

  .canva-btn-size-s {
    height: 32px;
    border-radius: 3px;
    font-size: 12px;
    padding-right: 12px;
  }

  .canva-btn-size-s .canva-btn-i {
    width: 20px;
    height: 20px;
    margin: 0 8px;
  }

  .canva-btn-size-xs {
    height: 24px;
    border-radius: 2px;
    font-size: 12px;
    padding-right: 8px;
  }

  .canva-btn-size-xs .canva-btn-i {
    width: 16px;
    height: 16px;
    margin-left: 6px;
    margin-right: 5px;
  }

  /* SVG files are inlined here just as an example. If you're going to use Canva logo in SVG format on your website, you can host SVG files and use them in CSS using URL in `background-image: url(...)`; */

  .canva-btn-theme-dark .canva-btn-i,
  .canva-btn-theme-light .canva-btn-i,
  .canva-btn-theme-default .canva-btn-i {
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='2' y='2' width='28' height='28'%3E%3Cpath d='M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63619 2.66669 2.66666 8.63622 2.66666 16C2.66666 23.3638 8.63619 29.3334 16 29.3334Z' fill='white'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.33331 1.33337H30.6666V30.6667H1.33331V1.33337Z' fill='%2300C4CC'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.4773 18.628C21.4479 18.498 21.3762 18.3814 21.2734 18.2965C21.1706 18.2115 21.0426 18.1631 20.9093 18.1587C20.8021 18.1551 20.696 18.182 20.6035 18.2363C20.511 18.2906 20.4358 18.37 20.3866 18.4654C20.3306 18.5507 20.28 18.6374 20.232 18.7187C20.1965 18.7797 20.16 18.8402 20.1226 18.9C19.496 19.8867 19.0026 20.324 17.8333 20.936C17.3078 21.2065 16.7269 21.352 16.136 21.3614C14.416 21.3614 13.416 19.8387 13.0826 18.5347C12.496 16.2254 13.4693 13.352 14.736 11.708C15.4546 10.7734 16.2573 10.2347 16.9386 10.232C17.1224 10.2379 17.3021 10.2874 17.463 10.3765C17.6239 10.4655 17.7613 10.5915 17.864 10.744C18.2213 11.3187 18.3373 11.8027 17.9306 12.712C17.8729 12.8495 17.8671 13.0032 17.9145 13.1446C17.9618 13.2859 18.0591 13.4052 18.188 13.48C18.528 13.6614 18.9466 13.4574 19.4013 12.8054C19.8813 12.1187 19.912 11.04 19.472 10.3494C18.9293 9.50005 17.8786 8.97205 16.7093 8.97205C15.893 8.97931 15.0946 9.21236 14.4026 9.64538C11.5226 11.4654 9.87196 15.668 10.724 19.012C11.028 20.2054 11.6973 21.284 12.5586 21.9747C12.8973 22.2414 14.112 23.112 15.5853 23.112H15.6026C17.088 23.1054 18.216 22.4747 18.9386 21.9987C19.728 21.4734 20.416 20.7507 21.0453 19.7894C21.0973 19.7107 21.148 19.6294 21.1973 19.5467L21.336 19.3214C21.4063 19.2219 21.4552 19.1089 21.4795 18.9896C21.5038 18.8702 21.5031 18.7471 21.4773 18.628ZM15.5853 22.8067V22.808V22.8067Z' fill='white'/%3E%3C/g%3E%3C/svg%3E%0A");
  }

  .canva-btn-theme-dark:hover .canva-btn-i,
  .canva-btn-theme-dark:focus .canva-btn-i,
  .canva-btn-theme-light:hover .canva-btn-i,
  .canva-btn-theme-light:focus .canva-btn-i,
  .canva-btn-theme-default:hover .canva-btn-i,
  .canva-btn-theme-default:focus .canva-btn-i {
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='2' y='2' width='28' height='28'%3E%3Cpath d='M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63619 2.66669 2.66666 8.63622 2.66666 16C2.66666 23.3638 8.63619 29.3334 16 29.3334Z' fill='white'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.33331 1.33337H30.6666V30.6667H1.33331V1.33337Z' fill='%2300D9E1'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.4773 18.628C21.4479 18.498 21.3762 18.3814 21.2734 18.2965C21.1706 18.2115 21.0426 18.1631 20.9093 18.1587C20.8021 18.1551 20.696 18.182 20.6035 18.2363C20.511 18.2906 20.4358 18.37 20.3866 18.4654C20.3306 18.5507 20.28 18.6374 20.232 18.7187C20.1965 18.7797 20.16 18.8402 20.1226 18.9C19.496 19.8867 19.0026 20.324 17.8333 20.936C17.3078 21.2065 16.7269 21.352 16.136 21.3614C14.416 21.3614 13.416 19.8387 13.0826 18.5347C12.496 16.2254 13.4693 13.352 14.736 11.708C15.4546 10.7734 16.2573 10.2347 16.9386 10.232C17.1224 10.2379 17.3021 10.2874 17.463 10.3765C17.6239 10.4655 17.7613 10.5915 17.864 10.744C18.2213 11.3187 18.3373 11.8027 17.9306 12.712C17.8729 12.8495 17.8671 13.0032 17.9145 13.1446C17.9618 13.2859 18.0591 13.4052 18.188 13.48C18.528 13.6614 18.9466 13.4574 19.4013 12.8054C19.8813 12.1187 19.912 11.04 19.472 10.3494C18.9293 9.50005 17.8786 8.97205 16.7093 8.97205C15.893 8.97931 15.0946 9.21236 14.4026 9.64538C11.5226 11.4654 9.87196 15.668 10.724 19.012C11.028 20.2054 11.6973 21.284 12.5586 21.9747C12.8973 22.2414 14.112 23.112 15.5853 23.112H15.6026C17.088 23.1054 18.216 22.4747 18.9386 21.9987C19.728 21.4734 20.416 20.7507 21.0453 19.7894C21.0973 19.7107 21.148 19.6294 21.1973 19.5467L21.336 19.3214C21.4063 19.2219 21.4552 19.1089 21.4795 18.9896C21.5038 18.8702 21.5031 18.7471 21.4773 18.628ZM15.5853 22.8067V22.808V22.8067Z' fill='white'/%3E%3C/g%3E%3C/svg%3E%0A");
  }

  .canva-btn-theme-dark:active .canva-btn-i,
  .canva-btn-theme-light:active .canva-btn-i,
  .canva-btn-theme-default:active .canva-btn-i {
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='2' y='2' width='28' height='28'%3E%3Cpath d='M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63619 2.66669 2.66666 8.63622 2.66666 16C2.66666 23.3638 8.63619 29.3334 16 29.3334Z' fill='white'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.33331 1.33337H30.6666V30.6667H1.33331V1.33337Z' fill='%2300AFB5'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.4773 18.628C21.4479 18.498 21.3762 18.3814 21.2734 18.2965C21.1706 18.2115 21.0426 18.1631 20.9093 18.1587C20.8021 18.1551 20.696 18.182 20.6035 18.2363C20.511 18.2906 20.4358 18.37 20.3866 18.4654C20.3306 18.5507 20.28 18.6374 20.232 18.7187C20.1965 18.7797 20.16 18.8402 20.1226 18.9C19.496 19.8867 19.0026 20.324 17.8333 20.936C17.3078 21.2065 16.7269 21.352 16.136 21.3614C14.416 21.3614 13.416 19.8387 13.0826 18.5347C12.496 16.2254 13.4693 13.352 14.736 11.708C15.4546 10.7734 16.2573 10.2347 16.9386 10.232C17.1224 10.2379 17.3021 10.2874 17.463 10.3765C17.6239 10.4655 17.7613 10.5915 17.864 10.744C18.2213 11.3187 18.3373 11.8027 17.9306 12.712C17.8729 12.8495 17.8671 13.0032 17.9145 13.1446C17.9618 13.2859 18.0591 13.4052 18.188 13.48C18.528 13.6614 18.9466 13.4574 19.4013 12.8054C19.8813 12.1187 19.912 11.04 19.472 10.3494C18.9293 9.50005 17.8786 8.97205 16.7093 8.97205C15.893 8.97931 15.0946 9.21236 14.4026 9.64538C11.5226 11.4654 9.87196 15.668 10.724 19.012C11.028 20.2054 11.6973 21.284 12.5586 21.9747C12.8973 22.2414 14.112 23.112 15.5853 23.112H15.6026C17.088 23.1054 18.216 22.4747 18.9386 21.9987C19.728 21.4734 20.416 20.7507 21.0453 19.7894C21.0973 19.7107 21.148 19.6294 21.1973 19.5467L21.336 19.3214C21.4063 19.2219 21.4552 19.1089 21.4795 18.9896C21.5038 18.8702 21.5031 18.7471 21.4773 18.628ZM15.5853 22.8067V22.808V22.8067Z' fill='white'/%3E%3C/g%3E%3C/svg%3E%0A");
  }
  .loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #fff;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
  </style>
